import React from "react";
import { Typography, Stack, useTheme, Paper, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ErrorState = ({ onRetry }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.palette.error.background,
        borderRadius: 1,
        padding: 2,
        mb: 2,
        width: "100%",
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: "10px" }}>
        <Stack direction="row" alignItems="center" spacing={5} sx={{ padding: "10px" }}>
          <ErrorOutlineIcon color="error" />
          <Typography variant="body1" sx={{ color: theme.palette.error.text }}>
            Oops! We couldn't generate your session note summary.
          </Typography>
        </Stack>

        <Button
          variant="text"
          size="small"
          sx={{ fontWeight: 500, color: theme.palette.error.text }}
          onClick={onRetry}
        >
          Try Again
        </Button>
      </Stack>
    </Paper>
  );
};

export default ErrorState;
